import {
  DownloadOutlined,
  FilterOutlined,
  LeftOutlined,
  LoadingOutlined,
} from '@ant-design/icons';
import { Button } from 'antd';
import ResponsivePageHeader, {
  HeaderFilterButton,
  HeaderIconButton,
} from 'components/UI/Responsive/ResponsivePageHeader';
import { useMyOrderIntentionsContext } from 'contexts/MyOrderIntentionsContext';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  myOrderIntentionEditSelectors,
  sessionSelectors,
} from 'store/state/selectors';
import {
  countActiveAdvancedFilters,
  describeAppliedPeriod,
} from '../Filter/orderIntentionsFilterValues';
import { useOrderIntentionsExport } from '../Filter/useOrderIntentionsExport';

import * as S from './styles';

interface Props {
  onOpenFilters?: () => void;
}

export default function OrderIntentionsResponsiveHeader({
  onOpenFilters,
}: Props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const producerUrl = useSelector(sessionSelectors.getProducerUrl);
  const filterExport = useSelector(
    myOrderIntentionEditSelectors.getFilterExport,
  );
  const { activeFilters } = useMyOrderIntentionsContext();
  const { exportReport, isExporting, canExport } = useOrderIntentionsExport();
  const period = filterExport
    ? describeAppliedPeriod(activeFilters)
    : undefined;
  const exportLabel = t('myOrderIntentions.exportReport');

  return (
    <S.Container>
      <S.BackButton
        type="button"
        onClick={() => navigate(`/${producerUrl}/products`)}
      >
        <LeftOutlined aria-hidden />
        {t('shoppingCart.continueShopping')}
      </S.BackButton>

      <ResponsivePageHeader
        title={t('myOrderIntentions.title')}
        subtitle={period ?? t('myOrderIntentions.legend')}
      >
        {onOpenFilters ? (
          <>
            <HeaderIconButton
              type="button"
              aria-label={exportLabel}
              aria-busy={isExporting}
              disabled={!canExport || isExporting}
              onClick={exportReport}
            >
              {isExporting ? (
                <LoadingOutlined aria-hidden />
              ) : (
                <DownloadOutlined aria-hidden />
              )}
            </HeaderIconButton>
            <HeaderFilterButton
              type="button"
              aria-label="Filtros"
              data-active={
                Boolean(filterExport) &&
                countActiveAdvancedFilters(activeFilters) > 0
              }
              onClick={onOpenFilters}
            >
              <FilterOutlined aria-hidden />
            </HeaderFilterButton>
          </>
        ) : (
          <Button
            type="primary"
            icon={<DownloadOutlined aria-hidden />}
            disabled={!canExport}
            loading={isExporting}
            onClick={exportReport}
          >
            {exportLabel}
          </Button>
        )}
      </ResponsivePageHeader>
    </S.Container>
  );
}
